__turbopack_context__.v({
  "bar": "GLx1Eq_bar",
  "body": "GLx1Eq_body",
  "caps": "GLx1Eq_caps",
  "header": "GLx1Eq_header",
  "index": "GLx1Eq_index",
  "ledger": "GLx1Eq_ledger",
  "machine": "GLx1Eq_machine",
  "machineIndex": "GLx1Eq_machineIndex",
  "machineKey": "GLx1Eq_machineKey",
  "machineList": "GLx1Eq_machineList",
  "machineMuted": "GLx1Eq_machineMuted",
  "machineRule": "GLx1Eq_machineRule",
  "machineTitle": "GLx1Eq_machineTitle",
  "pill": "GLx1Eq_pill",
  "row": "GLx1Eq_row",
  "rowText": "GLx1Eq_rowText",
  "rowTitle": "GLx1Eq_rowTitle",
  "title": "GLx1Eq_title",
  "titleMark": "GLx1Eq_titleMark",
  "titleRow": "GLx1Eq_titleRow",
});
